import axios from '@/axios.js'
import network from '../../http/requests/network/index.js'

export default {
    setTimeframe({ state, commit }, timeframe) {
        commit('SET_ACTIVE_TIMEFRAME', timeframe);
    },
    setActiveNetwork({ state, commit }, network) {
        commit('SET_ACTIVE_NETWORK', network.id);
    },
    fetchNetworkPlayersGraph({ state, commit }, points) {
        return new Promise((resolve, reject) => {
            network.
                getPlayersGraph(state.loadedNetworkID, points, state.loadedTimeframe)
                .then(response => {
                    let responseSeries = {
                        name: 'Players',
                        data: response.data,
                    };
                    commit('UPDATE_NETWORK_PLAYERS', responseSeries);
                    resolve(responseSeries);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    fetchNetworkConnectionsGraph({ state, commit }, points) {
        return new Promise((resolve, reject) => {
            network.
                getConnectionsGraph(state.loadedNetworkID, points, state.loadedTimeframe)
                .then(response => {
                    let responseSeries = {
                        name: 'Connections',
                        data: response.data,
                    };
                    commit('UPDATE_NETWORK_CONNECTIONS', responseSeries);
                    resolve(responseSeries);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    fetchNetworkTopDomains({ state, commit }) {
        return new Promise((resolve, reject) => {
            network.
                getPlayersGraph(state.loadedNetworkID, state.loadedTimeframe)
                .then(response => {
                    let responseSeries = {
                        name: 'Players',
                        data: response.data,
                    };
                    commit('UPDATE_NETWORK_TOP_DOMAINS', responseSeries);
                    resolve(responseSeries);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },
};